export default "__VITE_ASSET__2a085929__"